import { urlParse } from "./commonFunc"

// 返回 menu 的active id
export const checkActiveMenuIdList = (menuList) => {
  const MenuIdList = flatMenuList(menuList)
  const activeMenu = checkActiveMenuId(MenuIdList)
  return activeMenu
}

// 纯函数 取出叶子结点menu的信息
const flatMenuList = (menuList) => {
  const MenuIdList = []
  menuList.forEach(item => {
    let subMenuIdList = []
    subMenuIdList = forEachMenu(item)
    MenuIdList.push(...subMenuIdList)
  })
  return MenuIdList
}

// 纯函数
const forEachMenu = (menu, idString = '') => {
  let subMenuIdList = [];
  if (menu.childMenus.length) {
    if (idString.length) {
      idString = idString + "_" + String(menu.id)
    } else {
      idString = String(menu.id)
    }
    menu.childMenus.forEach((item) => {
      subMenuIdList = subMenuIdList.concat(forEachMenu(item, idString))
    })
  } else {
    if (idString.length) {
      idString = String(menu.id) + "_" + idString
    } else {
      idString = String(menu.id)
    }
    subMenuIdList.push({
      url: menu.url,
      name: menu.name,
      id: idString,
    })
  }
  return subMenuIdList
}

const checkActiveMenuId = (MenuIdList) => {
  const url = window.location
  let activeMenu = {
    name: '',
    activeMenuIdList: []
  }
  const urlParseObj = urlParse(url)

  MenuIdList.forEach(item => {
    const itemUrl = item.url.includes("http") ? new URL(item.url) : new URL(window.location.origin + item.url)
    const itemUrlObj = urlParse(itemUrl)
    const search = Object.keys(itemUrlObj).every((item) => {
      return itemUrlObj[item] === urlParseObj[item]
    })
    // ticket全量后，可不对/ticket做特殊处理
    // const isActiveMenu = url.pathname === itemUrl.pathname && url.hash.replace("#/", "").split("?")[0] === itemUrl.hash.replace("#/", "").split("?")[0] && search
    const isActiveMenu = (url.pathname === itemUrl.pathname || url.pathname.replace("/ticket", "") === itemUrl.pathname) && url.hash.replace("#/", "").split("?")[0] === itemUrl.hash.replace("#/", "").split("?")[0] && search
    if (isActiveMenu) {
      activeMenu.name = item.name
      activeMenu.activeMenuIdList = item.id.split('_').map(Number)
    }
  })
  return activeMenu
}